import BaseContentDetailsDetailsSubPageView from "scripts/views/baseContentDetailsDetailsSubPageView";
import templateContentDetailsDocumentPageDetailsSubPage from "templates/contentDetailsDocumentPageDetailsSubPage.hbs";

class ContentDetailsDocumentPageDetailsSubPageView extends BaseContentDetailsDetailsSubPageView {
  get template() {
    return templateContentDetailsDocumentPageDetailsSubPage;
  }
}

export default ContentDetailsDocumentPageDetailsSubPageView;
